{

    "Allocation-Quick-Search-Fields": [
        {
            "label": "Event Type", "columnname": "EventType", "placeholder": "Event Type",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OrderID", "columnname": "OrderID", "placeholder": "OrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "AllocationID", "columnname": "AllocationID", "placeholder": "AllocationID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "TradeID", "columnname": "TradeID", "placeholder": "TradeID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Customer ID", "columnname": "CustomerAccount", "placeholder": "Customer ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "FirmDesignatedID", "columnname": "firmDesignatedID", "placeholder": "FirmDesignatedID",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "Allocation-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "EventType",
            "datatype": "String",
            "mappingkey": "EventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AllocationDateTime",
            "db_columnname": "AllocationDateTime",
            "datatype": "String",
            "mappingkey": "AllocationDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AllocationID",
            "db_columnname": "AllocationID",
            "datatype": "String",
            "mappingkey": "AllocationID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "OrderID",
            "datatype": "String",
            "mappingkey": "OrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradeID",
            "db_columnname": "TradeID",
            "datatype": "String",
            "mappingkey": "TradeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradeDateTime",
            "db_columnname": "TradeDateTime",
            "datatype": "String",
            "mappingkey": "TradeDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AllocationType",
            "db_columnname": "AllocationType",
            "datatype": "String",
            "mappingkey": "AllocationType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "Symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "BuySellCode",
            "datatype": "String",
            "mappingkey": "BuySellCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "Quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "Price",
            "datatype": "Float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Capacity",
            "db_columnname": "Capacity",
            "datatype": "String",
            "mappingkey": "Capacity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AsOf",
            "db_columnname": "AsOf",
            "datatype": "String",
            "mappingkey": "AsOf",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ClearingBrokerMPID",
            "db_columnname": "ClearingBrokerMPID",
            "datatype": "String",
            "mappingkey": "ClearingBrokerMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustomerAccount",
            "db_columnname": "CustomerAccount",
            "datatype": "char",
            "mappingkey": "CustomerAccount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firmDesignatedID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TerminalUser",
            "db_columnname": "TerminalUser",
            "datatype": "String",
            "mappingkey": "TerminalUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SettleDate",
            "db_columnname": "SettleDate",
            "datatype": "String",
            "mappingkey": "SettleDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ReceiveMethod",
            "db_columnname": "ReceiveMethod",
            "datatype": "String",
            "mappingkey": "ReceiveMethod",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustomerType",
            "db_columnname": "CustomerType",
            "datatype": "String",
            "mappingkey": "CustomerType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LegID",
            "db_columnname": "LegID",
            "datatype": "String",
            "mappingkey": "LegID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ForeignSymbol",
            "db_columnname": "ForeignSymbol",
            "datatype": "String",
            "mappingkey": "ForeignSymbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ForeignPrice",
            "db_columnname": "ForeignPrice",
            "datatype": "String",
            "mappingkey": "ForeignPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Exchange",
            "db_columnname": "Exchange",
            "datatype": "String",
            "mappingkey": "Exchange",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OMSSystem",
            "db_columnname": "OMSSystem",
            "datatype": "String",
            "mappingkey": "OMSSystem",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "InstrumentType",
            "db_columnname": "InstrumentType",
            "datatype": "String",
            "mappingkey": "InstrumentType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DVPCustodianID",
            "db_columnname": "DVPCustodianID",
            "datatype": "String",
            "mappingkey": "DVPCustodianID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CorrespondentCRD",
            "db_columnname": "CorrespondentCRD",
            "datatype": "String",
            "mappingkey": "CorrespondentCRD",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NewOrderFDID",
            "db_columnname": "NewOrderFDID",
            "datatype": "String",
            "mappingkey": "NewOrderFDID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "allocationInstructionTime",
            "db_columnname": "allocationInstructionTime",
            "datatype": "String",
            "mappingkey": "allocationInstructionTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelTimeStamp",
            "db_columnname": "CancelTimeStamp",
            "datatype": "String",
            "mappingkey": "CancelTimeStamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "priorAllocationKeyDate",
            "db_columnname": "priorAllocationKeyDate",
            "datatype": "String",
            "mappingkey": "priorAllocationKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "priorAllocationID",
            "db_columnname": "priorAllocationID",
            "datatype": "String",
            "mappingkey": "priorAllocationID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AllocationState",
            "db_columnname": "AllocationState",
            "datatype": "String",
            "mappingkey": "AllocationState",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AccountHolderType",
            "db_columnname": "accountHolderType",
            "datatype": "String",
            "mappingkey": "accountHolderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "Updated_Date",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "Updated_By",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "Allocation-Opted-Export-CSV-Grid-Columns": [
        {
            "columnName": "Event Type",
            "dbFieldValue": "EventType"
        },
        {
            "columnName": "AllocationDateTime",
            "dbFieldValue": "AllocationDateTime"
        },
        {
            "columnName": "AllocationID",
            "dbFieldValue": "AllocationID"
        },
        {
            "columnName": "OrderID",
            "dbFieldValue": "OrderID"
        },
        {
            "columnName": "TradeID",
            "dbFieldValue": "TradeID"
        },
        {
            "columnName": "TradeDateTime",
            "dbFieldValue": "TradeDateTime"
        },
        {
            "columnName": "AllocationType",
            "dbFieldValue": "AllocationType"
        },
        {
            "columnName": "Symbol",
            "dbFieldValue": "Symbol"
        },
        {
            "columnName": "Side",
            "dbFieldValue": "BuySellCode"
        },
        {
            "columnName": "Quantity",
            "dbFieldValue": "Quantity"
        },
        {
            "columnName": "Price",
            "dbFieldValue": "Price"
        },
        {
            "columnName": "Capacity",
            "dbFieldValue": "Capacity"
        },
        {
            "columnName": "ClearingBrokerMPID",
            "dbFieldValue": "ClearingBrokerMPID"
        },
        {
            "columnName": "CustomerAccount",
            "dbFieldValue": "CustomerAccount"
        },
        {
            "columnName": "firmDesignatedID",
            "dbFieldValue": "firmDesignatedID"
        },
        {
            "columnName": "TerminalUser",
            "dbFieldValue": "TerminalUser"
        },
        {
            "columnName": "SettleDate",
            "dbFieldValue": "SettleDate"
        },
        {
            "columnName": "ReceiveMethod",
            "dbFieldValue": "ReceiveMethod"
        },
        {
            "columnName": "CustomerType",
            "dbFieldValue": "CustomerType"
        },
        {
            "columnName": "LegID",
            "dbFieldValue": "LegID"
        },
        {
            "columnName": "InstrumentType",
            "dbFieldValue": "InstrumentType"
        },
        {
            "columnName": "DVPCustodianID",
            "dbFieldValue": "DVPCustodianID"
        },
        {
            "columnName": "CorrespondentCRD",
            "dbFieldValue": "CorrespondentCRD"
        },
        {
            "columnName": "NewOrderFDID",
            "dbFieldValue": "NewOrderFDID"
        },
        {
            "columnName": "allocationInstructionTime",
            "dbFieldValue": "allocationInstructionTime"
        },
        {
            "columnName": "CancelTimeStamp",
            "dbFieldValue": "CancelTimeStamp"
        },
        {
            "columnName": "priorAllocationKeyDate",
            "dbFieldValue": "priorAllocationKeyDate"
        },
        {
            "columnName": "priorAllocationID",
            "dbFieldValue": "priorAllocationID"
        },
        {
            "columnName": "AllocationState",
            "dbFieldValue": "AllocationState"
        },
        {
            "columnName": "AccountHolderType",
            "dbFieldValue": "accountHolderType"
        },
        {
            "columnName": "Created Date",
            "dbFieldValue": "createdDate"
        },
        {
            "columnName": "Updated Date",
            "dbFieldValue": "updatedDate"
        },
        {
            "columnName": "User",
            "dbFieldValue": "user"
        }
    ]
}